// extracted by mini-css-extract-plugin
module.exports = {"container":"DocumentForm_container__27Tjq","column":"DocumentForm_column__1eOQa"};